
import { ReportCofig, ResponseWithMeta, useRequest } from 'src/shared/api';
import { apiRoutesMap } from 'src/shared/config';

export const useGetReportsList = () =>
  useRequest<ResponseWithMeta<ReportCofig[]>>(apiRoutesMap.reportsList.getRoute());
